<template>
  <div v-if="prepareTermsOfPaymentList.length > 0">
    <div :style="{ textAlign: termsOfPaymentFormat.align }">
      <div v-if="termsOfPaymentFormat.multiline">
        <p class="avoid" style="margin: 30px 0 15px;"><strong>Terms of payment: </strong></p>
        <div v-for="(termsOfPayment, index) of prepareTermsOfPaymentList" :key="`terms-payment-${index}`" class="avoid">
          <p class="avoid" v-html="bindTermsOfPayment(termsOfPayment)"></p>
        </div>
      </div>
      <div v-if="!termsOfPaymentFormat.multiline">
        <p class="avoid">
          <strong class="avoid">Terms of payment: </strong>
          <span v-for="(termsOfPayment, index) of prepareTermsOfPaymentList" :key="`terms-payment-${index}`">
            <span class="avoid" v-html="bindTermsOfPayment(termsOfPayment)"></span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'

export default {
  name: 'TermOfPayment',
  computed: {
    prepareTermsOfPaymentList: function () {
      const dataList = this.dataList || []

      return dataList
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    termsOfPaymentFormat: {
      type: Object,
      default: () => {
        return {
          align: 'left',
          multiline: true
        }
      }
    }
  },
  methods: {
    bindTermsOfPayment: function (termOfPayment) {
      const multiline = get(this.termsOfPaymentFormat, 'multiline', true)
      const htmlTag = 'span'
      const newLine = (multiline) ? '<br>' : ' '

      const name = get(termOfPayment, 'name', '')
      const termOfPaymentDetail = get(termOfPayment, 'detail', '')
      const detail = termOfPaymentDetail.replace(/(?:\r\n|\r|\n)/g, newLine)

      let termsOfPaymentHtml = ''

      if (name !== '') {
        termsOfPaymentHtml += `<span><strong>${name}</strong></span>` + newLine
      }

      if (detail !== '') {
        termsOfPaymentHtml += `<${htmlTag}>${detail}</${htmlTag}> `
      }

      return termsOfPaymentHtml
    }
  }
}
</script>
